import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import { mapCostCenterDetailFromTransport } from '../mappers';
import type { CostCenterDetail, LC_GetCostCenterByIdOut } from '../types';


export class CostCenterDetailService {
  async getById(costCenterId: number): Promise<ApiResponse<CostCenterDetail>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.COST_CENTER_BY_ID(costCenterId);
    const response = await apiClient.get<LC_GetCostCenterByIdOut>(endpoint);
    if (response.success && response.data) {
      return { ...response, data: mapCostCenterDetailFromTransport(response.data) };
    }
    return { ...response, data: null };
  }
}

export const costCenterDetail = new CostCenterDetailService();
